import { Alert, Box, Grid, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useApi from "../../hooks/useApi";
import { useNavigate } from "react-router-dom";
import styles from "../../components/globalstyles";
import { LoadingButton } from "@mui/lab";
import { useUser } from "../../hooks/useUser";
import useLogos from "../../hooks/useLogos";
import bg from "../../assets/wallpaper-login.webp";

const Login = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const { loadApi, loadingApi, errorApi } = useApi();
  const { logo: logoBarra, logoClaro, home } = useLogos();
  const logo = home || bg;
  const { setUser } = useUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const directIntent = searchParams.get("intent");

  useEffect(() => {
    if (!directIntent) return;
    loadApi(
      `general/direct-links/intent/${encodeURIComponent(directIntent)}`,
      false,
      "get"
    )
      .then(({ data }) => {
        if (data.email) {
          setForm((prev) => ({
            ...prev,
            username: prev.username || data.email,
          }));
        }
      })
      .catch(() => {});
  }, [directIntent]);

  function handleSignin(e) {
    e.preventDefault();
    setForm((data) => {
      if (data.username) data["username"] = data.username.toLowerCase();
      return data;
    });

    loadApi("login", false, "post", form)
      .then(async (response) => {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setUser(response.data.user);

        if (directIntent) {
          try {
            const { data } = await loadApi(
              `artista/direct-links/claim/${encodeURIComponent(directIntent)}`,
              true,
              "post",
              {}
            );
            navigate(
              `/artista/envios?pedido=${encodeURIComponent(
                data.envioId || ""
              )}&direct=1`
            );
            return;
          } catch (e) {
            // Si entró con otra cuenta o todavía falta resolver algo del
            // pedido, la pantalla de activación explica el caso concreto.
            navigate(
              `/direct-link/activar?intent=${encodeURIComponent(directIntent)}`
            );
            return;
          }
        }

        navigate("/");
      })
      .catch(() => {});
  }

  return (
    <>
      {/* HEADER (SOLO MOVIL) */}
      <Box sx={styles.barramovil}>
        <img
          src={logoBarra}
          alt="Radar Freim"
          style={{ maxWidth: "180px", objectFit: "contain" }}
        />
      </Box>
      <Grid container sx={styles.root}>
        {/* VISTA IZQUIERDA */}
        <Grid
          item
          xs={false}
          md={7}
          sx={{
            ...styles.image,
            backgroundImage: `url(${logo})`,
          }}
        />
        {/* VISTA DERECHA */}
        <Grid
          container
          item
          direction="column"
          justifyContent="center"
          md={5}
          mt={2}
          px={4}
        >
          <Grid item justifyContent="center" display="flex">
            <img
              alt="logo"
              src={logoClaro}
              style={{
                maxHeight: "120px",
                maxWidth: "280px",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Grid>
          <Grid item mt={2}>
            <Typography sx={styles.title}>Acceder</Typography>
          </Grid>
          {directIntent && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Inicia sesión con el correo de tu solicitud. Al entrar te
              llevaremos directamente a tu pedido en Mis envíos.
            </Alert>
          )}
          <Box component="form" role="form" onSubmit={handleSignin}>
            <Grid container item direction="column">
              <Grid item mb={2} justifyContent="center" display="flex">
                {errorApi && (
                  <Alert sx={{ width: "100%" }} severity="error">
                    {errorApi}
                  </Alert>
                )}
              </Grid>
              <Grid item justifyContent="center" display="flex">
                <TextField
                  color="warning"
                  variant="outlined"
                  fullWidth
                  label="Correo Electronico*"
                  value={form.username}
                  onChange={(e) =>
                    setForm({ ...form, username: e.target.value })
                  }
                  name="email"
                  type="email"
                />
              </Grid>
            </Grid>
            <Grid container item direction="column" mt={2}>
              <Grid item justifyContent="center" display="flex">
                <TextField
                  fullWidth
                  color="warning"
                  variant="outlined"
                  label="Contraseña*"
                  onChange={(e) =>
                    setForm({ ...form, password: e.target.value })
                  }
                  name="password"
                  type="password"
                  id="password"
                />
              </Grid>
            </Grid>
            <Grid item mt={1} display="flex" justifyContent="end" mr={3}>
              <Link to="/recover-password">
                <Typography sx={{ textDecoration: "underline" }}>
                  ¿Has olvidado tu contraseña?
                </Typography>
              </Link>
            </Grid>
            <Grid item mt={3} display="flex" justifyContent="center">
              <LoadingButton
                loading={loadingApi.includes("post__login")}
                variant="contained"
                type="submit"
                sx={styles.button}
              >
                Iniciar sesión
              </LoadingButton>
            </Grid>
          </Box>
          {!directIntent && (
            <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
              <Typography> ¿Aún no tienes cuenta? </Typography>
              <Link to="/register">
                <Typography color="primary" sx={{ textDecoration: "underline" }}>
                  Regístrate
                </Typography>
              </Link>
            </Stack>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Login;
